import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import CordwoodName from "../../components/cordwood/CordwoodDetail/CordwoodName.tsx";
import {useLocationFormState} from "../../components/cordwood/CordwoodForm/CordwoodUpdateForm";
import CordwoodUpdateFormProvider from "../../components/cordwood/CordwoodForm/CordwoodUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const CordwoodUpdateEditPage = () => {
    
    useTitle(t`Update Cordwood`);

    const { cordwoodId: id } = useParams();
    
    return (
        <Box data-testid="Cordwood-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="Cordwood-update-title"
                    >
                        <Trans>Edit Cordwood</Trans>:  <CordwoodName id={id}/>
                    </Typography>
                    <CordwoodUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default CordwoodUpdateEditPage;
